'use es6';

import { OrderedMap, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { combineReducers } from 'redux';
import ActionTypes from 'AdsUI/lib/Actions'; // When our version of Immutable catches up and this is a function on Map, feel free to delete this.

const deleteAll = (map, keysToDelete) => map.withMutations(newMap => keysToDelete.reduce((mapWithDeletions, keyToDelete) => mapWithDeletions.delete(keyToDelete), newMap));

const bannerReducers = area => {
  return (state = OrderedMap(), action) => {
    const {
      type,
      bannerType,
      pages = []
    } = action;

    switch (type) {
      // BANNER_HEADER_ADD
      // BANNER_BODY_ADD
      case ActionTypes[`BANNER_${area}_ADD`]:
        return state.has(bannerType) ? state.mergeIn([bannerType], pages) : state.set(bannerType, ImmutableSet(pages));
      // BANNER_HEADER_REMOVE
      // BANNER_BODY_REMOVE

      case ActionTypes[`BANNER_${area}_REMOVE`]:
        if (state.has(bannerType)) {
          return !pages.length ? state.remove(bannerType) : state.withMutations(newState => {
            const prevPages = newState.get(bannerType);
            const newPages = prevPages.subtract(pages);
            return newPages.isEmpty() ? newState.remove(bannerType) : newState.set(bannerType, newPages);
          });
        } else {
          return state;
        }

      // BANNER_HEADER_CLEAR
      // BANNER_BODY_CLEAR

      case ActionTypes[`BANNER_${area}_CLEAR_ALL`]:
        return state.clear();

      default:
        return state;
    }
  };
};

const bannerOptionsReducers = area => {
  return (state = ImmutableMap(), action) => {
    const {
      type,
      bannerType,
      pages = [],
      options
    } = action;

    switch (type) {
      // BANNER_HEADER_ADD
      // BANNER_BODY_ADD
      case ActionTypes[`BANNER_${area}_ADD`]:
        if (options) {
          return !pages.length ? state.set(bannerType, options) : state.withMutations(newState => {
            pages.forEach(page => {
              newState = newState.set(`${bannerType}_${page}`, options);
            });
            return newState;
          });
        } else {
          return state;
        }

      // BANNER_HEADER_REMOVE
      // BANNER_BODY_REMOVE

      case ActionTypes[`BANNER_${area}_REMOVE`]:
        if (!state.isEmpty()) {
          return !pages.length ? state.delete(bannerType) : deleteAll(state, pages.map(page => `${bannerType}_${page}`));
        } else {
          return state.clear();
        }

      // BANNER_HEADER_CLEAR
      // BANNER_BODY_CLEAR

      case ActionTypes[`BANNER_${area}_CLEAR_ALL`]:
        return state.clear();

      default:
        return state;
    }
  };
};

export default combineReducers({
  header: combineReducers({
    banners: bannerReducers('HEADER'),
    options: bannerOptionsReducers('HEADER')
  }),
  body: combineReducers({
    banners: bannerReducers('BODY'),
    options: bannerOptionsReducers('BODY')
  })
});